import { axios } from 'lib/axios';
import { useQuery } from 'react-query';

export const getInActiveCustomers = ({ pageNumber }) => {
  return axios.get(`/customer/inactive/${pageNumber}`);
};

export const useInActiveCustomers = ({ pageNumber, config }) => {
  return useQuery({
    ...config,
    queryKey: ['inactiveUsers', pageNumber],
    queryFn: () => getInActiveCustomers({ pageNumber }),
  });
};
